import React from "react";
import { Box, Chip } from "@mui/material";
import { AccountBalance, AccountBalanceWallet } from "@mui/icons-material";
import { useAppState } from "../store/contextProvider";

const TradingModeDisplay = () => {
  const { theme } = useAppState();
  const isLive = theme?.mode === "LT";

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Chip
        icon={isLive ? <AccountBalance /> : <AccountBalanceWallet />}
        label={isLive ? "Live Trading" : "Paper Trading"}
        variant="outlined"
        size="small"
        sx={{
          color: "inherit",
          borderColor: "rgba(255,255,255,0.3)",
          "& .MuiChip-icon": { color: "inherit" },
        }}
      />
    </Box>
  );
};

export default TradingModeDisplay;
